(function () {
  if (window.__tathaWishlistJsLoaded) return;
  window.__tathaWishlistJsLoaded = true;

  /** Legacy single bucket — migrated once into scoped keys so logout does not reuse account data. */
  var LEGACY_WISHLIST_KEY = 'tathaWishlist';
  var TOAST_MS = 4800;
  var TOAST_MS_WITH_ACTION = 5800;
  var TOAST_HIDE_MS = 360;

  function getWishlistStorageKey() {
    try {
      var root = document.documentElement;
      if (root && root.dataset && root.dataset.wishlistStorageKey) {
        return String(root.dataset.wishlistStorageKey).trim() || LEGACY_WISHLIST_KEY;
      }
    } catch (e) {}
    return LEGACY_WISHLIST_KEY;
  }

  function readWishlist() {
    var key = getWishlistStorageKey();
    try {
      var raw = localStorage.getItem(key);
      if (raw != null && raw !== '') {
        var parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
      }
    } catch (error) {
      return [];
    }
    /* First visit after scoped keys: move old flat list into this session’s bucket only */
    try {
      var legacyRaw = localStorage.getItem(LEGACY_WISHLIST_KEY);
      if (!legacyRaw) return [];
      var legacyParsed = JSON.parse(legacyRaw);
      var arr = Array.isArray(legacyParsed) ? legacyParsed : [];
      if (arr.length) {
        localStorage.setItem(key, JSON.stringify(arr));
        localStorage.removeItem(LEGACY_WISHLIST_KEY);
      }
      return arr;
    } catch (e2) {
      return [];
    }
  }

  function writeWishlist(items) {
    localStorage.setItem(getWishlistStorageKey(), JSON.stringify(items));
  }

  function formatMoney(cents) {
    var safeCents = Number(cents) || 0;
    return 'Rs. ' + (safeCents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function escapeHtml(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function upsertWishlistItem(item) {
    var items = readWishlist();
    var index = items.findIndex(function (entry) {
      return String(entry.productId) === String(item.productId);
    });

    if (index > -1) {
      items[index] = item;
    } else {
      items.unshift(item);
    }
    writeWishlist(items);
  }

  function removeWishlistItem(productId) {
    var items = readWishlist().filter(function (entry) {
      return String(entry.productId) !== String(productId);
    });
    writeWishlist(items);
    return items;
  }

  function toastMessagesFromHost(host) {
    var defAdded = 'Added to your wishlist';
    var defAlready = 'Already in your wishlist';
    if (!host || !host.dataset) {
      return { added: defAdded, already: defAlready };
    }
    return {
      added: host.dataset.wishlistToastAdded || defAdded,
      already: host.dataset.wishlistToastAlready || defAlready,
    };
  }

  function ariaAddedFromHost(host) {
    var def = 'Added to wishlist';
    return (host && host.dataset && host.dataset.wishlistAriaAdded) || def;
  }

  function ariaAddFromHost(host) {
    var def = 'Add to wishlist';
    return (host && host.dataset && host.dataset.wishlistAriaAdd) || def;
  }

  function showWishlistToast(message, host) {
    var existing = document.getElementById('tatha-wishlist-toast');
    if (existing) {
      existing.remove();
    }

    var viewUrl =
      host && host.dataset && host.dataset.wishlistViewUrl ? String(host.dataset.wishlistViewUrl).trim() : '';
    var viewLabel =
      host && host.dataset && host.dataset.wishlistViewLabel ? String(host.dataset.wishlistViewLabel).trim() : '';
    if (viewUrl && !viewLabel) {
      viewLabel = 'View wishlist';
    }

    var el = document.createElement('div');
    el.id = 'tatha-wishlist-toast';
    el.className = 'wishlist-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');

    var row = document.createElement('div');
    row.className = 'wishlist-toast__row';

    var icon = document.createElement('span');
    icon.className = 'wishlist-toast__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = '\u2713';

    var body = document.createElement('div');
    body.className = 'wishlist-toast__body';

    var msg = document.createElement('p');
    msg.className = 'wishlist-toast__message';
    msg.textContent = message;
    body.appendChild(msg);

    if (viewUrl) {
      var action = document.createElement('a');
      action.href = viewUrl;
      action.className = 'wishlist-toast__action';
      action.textContent = viewLabel;
      body.appendChild(action);
    }

    row.appendChild(icon);
    row.appendChild(body);
    el.appendChild(row);
    document.body.appendChild(el);

    requestAnimationFrame(function () {
      el.classList.add('wishlist-toast--visible');
    });

    var visibleMs = viewUrl ? TOAST_MS_WITH_ACTION : TOAST_MS;
    setTimeout(function () {
      el.classList.remove('wishlist-toast--visible');
      setTimeout(function () {
        el.remove();
      }, TOAST_HIDE_MS);
    }, visibleMs);
  }

  function syncWishlistButtonStates() {
    var items = readWishlist();
    var ids = {};
    items.forEach(function (entry) {
      ids[String(entry.productId)] = true;
    });

    document.querySelectorAll('[data-wishlist-button]').forEach(function (button) {
      var pid = button.dataset.productId;
      if (!pid) return;
      var host = button.closest('product-info');
      if (ids[String(pid)]) {
        button.classList.add('is-added-to-wishlist');
        button.setAttribute('aria-label', ariaAddedFromHost(host));
      } else {
        button.classList.remove('is-added-to-wishlist');
        button.setAttribute('aria-label', ariaAddFromHost(host));
      }
    });
  }

  function setWishlistButtonLoading(button, isLoading) {
    if (!button) return;

    button.classList.toggle('is-loading', isLoading);
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    button.disabled = !!isLoading;

    if (button.__wishlistLoaderTimer) {
      clearTimeout(button.__wishlistLoaderTimer);
      button.__wishlistLoaderTimer = null;
    }
  }

  function onDocumentClick(event) {
    var button = event.target.closest('[data-wishlist-button]');
    if (!button || !document.documentElement.contains(button)) return;
    if (button.classList.contains('is-loading')) return;

    setWishlistButtonLoading(button, true);

    var item = {
      productId: button.dataset.productId,
      handle: button.dataset.productHandle,
      url: button.dataset.productUrl,
      title: button.dataset.productTitle,
      image: button.dataset.productImage,
      variantId: button.dataset.variantId,
      priceCents: Number(button.dataset.priceCents) || 0,
      compareAtCents: Number(button.dataset.compareAtCents) || 0,
    };

    var items = readWishlist();
    var existed = items.some(function (entry) {
      return String(entry.productId) === String(item.productId);
    });

    upsertWishlistItem(item);

    var host = button.closest('product-info');
    var msgs = toastMessagesFromHost(host);
    showWishlistToast(existed ? msgs.already : msgs.added, host);

    button.classList.add('is-added-to-wishlist');
    button.setAttribute('aria-label', ariaAddedFromHost(host));
    button.__wishlistLoaderTimer = setTimeout(function () {
      setWishlistButtonLoading(button, false);
    }, 450);
  }

  function renderWishlist() {
    var listRoot = document.querySelector('[data-account-wishlist-list]');
    if (!listRoot) return;

    var items = readWishlist();

    if (!items.length) {
      listRoot.innerHTML = '<p class="account-wishlist__empty">Your wishlist is empty.</p>';
      return;
    }

    var html = items
      .map(function (item) {
        var oldPrice = '';
        if (Number(item.compareAtCents) > Number(item.priceCents)) {
          oldPrice = '<span class="account-wishlist__price-old">' + formatMoney(item.compareAtCents) + '</span>';
        }

        var safeTitle = escapeHtml(item.title || '');
        var safeUrl = escapeHtml(item.url || '#');
        var safeImage = escapeHtml(item.image || '');

        return (
          '<article class="account-wishlist__item" data-wishlist-item="' +
          escapeHtml(String(item.productId)) +
          '">' +
          '<a class="account-wishlist__media" href="' +
          safeUrl +
          '">' +
          '<img src="' +
          safeImage +
          '" alt="' +
          safeTitle +
          '" loading="lazy" width="60" height="60">' +
          '</a>' +
          '<div class="account-wishlist__content">' +
          '<a class="account-wishlist__title" href="' +
          safeUrl +
          '">' +
          safeTitle +
          '</a>' +
          '<div class="account-wishlist__price">' +
          oldPrice +
          '<span class="account-wishlist__price-current">' +
          formatMoney(item.priceCents) +
          '</span></div>' +
          '</div>' +
          '<button type="button" class="account-wishlist__remove" data-wishlist-remove="' +
          escapeHtml(String(item.productId)) +
          '" aria-label="Remove item">×</button>' +
          '</article>'
        );
      })
      .join('');

    listRoot.innerHTML = html;

    listRoot.querySelectorAll('[data-wishlist-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var remaining = removeWishlistItem(btn.dataset.wishlistRemove);
        if (!remaining.length) {
          listRoot.innerHTML = '<p class="account-wishlist__empty">Your wishlist is empty.</p>';
        } else {
          renderWishlist();
        }
        syncWishlistButtonStates();
      });
    });
  }

  function attachWishlistAddAll() {
    var addAllButton = document.querySelector('[data-wishlist-add-all]');
    if (!addAllButton) return;

    addAllButton.addEventListener('click', function () {
      var items = readWishlist().filter(function (entry) {
        return entry.variantId;
      });
      if (!items.length) return;

      Promise.all(
        items.map(function (entry) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: Number(entry.variantId),
              quantity: 1,
            }),
          });
        }),
      ).then(function () {
        window.location.href = '/cart';
      });
    });
  }

  function subscribeVariantSync() {
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var d = event && event.data;
      if (!d || !d.variant) return;

      var sectionId = d.sectionId;
      var variant = d.variant;
      var root = document.querySelector('product-info[data-section="' + sectionId + '"]');
      if (!root) return;

      var btn = root.querySelector('[data-wishlist-button]');
      if (!btn) return;

      btn.dataset.variantId = String(variant.id);
      btn.dataset.priceCents = String(variant.price != null ? variant.price : '');
      btn.dataset.compareAtCents = String(variant.compare_at_price != null ? variant.compare_at_price : 0);

      var feat = variant.featured_image || variant.featured_media;
      if (feat && feat.src) {
        var src = feat.src;
        var sep = src.indexOf('?') >= 0 ? '&' : '?';
        btn.dataset.productImage = src + sep + 'width=160';
      }
    });
  }

  document.addEventListener('click', onDocumentClick);

  document.addEventListener('DOMContentLoaded', function () {
    syncWishlistButtonStates();
    renderWishlist();
    attachWishlistAddAll();
    subscribeVariantSync();
  });

  window.addEventListener('storage', function (e) {
    if (e.key === getWishlistStorageKey()) {
      renderWishlist();
      syncWishlistButtonStates();
    }
  });
})();
